import React, { createContext, useContext, useEffect, useState } from "react";
import { getModuliAttivi } from "./api";

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [moduloAttivo, setModuloAttivo] = useState(null); // "diba" | "ddt" | null: quale tracciato è caricato in "tracciato"
  const [tracciato, setTracciato] = useState(null);
  const [fileCaricato, setFileCaricato] = useState(null); // { fileId, nomeOriginale, headers, totaleRighe, anteprima }
  const [templateAttivo, setTemplateAttivo] = useState(null); // { id, cliente, mapping, colonneNascoste } oppure null se nuovo
  const [mapping, setMapping] = useState({}); // { chiaveTracciato: { tipo, colonna|valore } }
  const [colonneNascoste, setColonneNascoste] = useState([]); // [chiaveTracciato, ...] nascoste in fase di mapping per questo template
  const [righeMappate, setRigheMappate] = useState(null);

  // Stato della sezione "scelta modello/template" di Home.jsx (Distinta
  // Base/DDT): vive qui e non come stato locale della pagina perché Home
  // si SMONTA quando si passa a Mapping/Revisione (route diverse) — senza
  // questo, tornare indietro da Revisione con "Torna indietro" faceva
  // sparire la conferma di cosa era stato applicato (modello PDF e/o
  // template), anche se il file/mapping erano ancora validi. Azzerati
  // insieme al resto del flusso in resetFlusso() qui sotto.
  const [pdfCaricato, setPdfCaricato] = useState(null); // { pdfId, nomeOriginale, totalePagine, avviso? } | null
  const [modelloPdfApplicato, setModelloPdfApplicato] = useState(null); // { id, cliente } | null
  const [templateApplicato, setTemplateApplicato] = useState(null); // template completo | null
  // Caricamento multiplo di PDF (Distinta Base/DDT): gli altri PDF oltre a
  // pdfCaricato/fileCaricato, mappati con lo stesso modello e template.
  // { extra: [{ pdfId, nomeOriginale }], scartati: [{ nomeOriginale, motivo }], file: [fileCaricato] } | null
  const [lottoPdf, setLottoPdf] = useState(null);

  // Canale dedicato SOLO per il ritorno dalla calibrazione PDF quando si
  // arriva da Import Ordini (pagina unica, senza gli stati Home/Mapping
  // condivisi di diba/ddt): si evita di riusare "fileCaricato" perché
  // resterebbe sporco se si passa da un modulo diba/ddt a Ordini senza
  // passare dalla calibrazione. OrdiniMapping.jsx lo consuma una volta sola
  // e lo azzera subito dopo.
  const [risultatoPdfOrdini, setRisultatoPdfOrdini] = useState(null);

  // Quali tab (diba/ddt/ordini) mostrare in "Cosa vuoi importare?" — null
  // finché non è ancora arrivata la risposta: Scelta.jsx e la guardia delle
  // rotte in App.js trattano "non ancora caricato" come "mostra tutto",
  // per non far sparire/ricomparire le card con uno sfarfallio ad ogni
  // avvio.
  const [moduliAttivi, setModuliAttivi] = useState(null);
  useEffect(() => { getModuliAttivi().then(setModuliAttivi).catch(() => {}); }, []);

  const resetFlusso = () => {
    setFileCaricato(null);
    setTemplateAttivo(null);
    setMapping({});
    setColonneNascoste([]);
    setRigheMappate(null);
    setPdfCaricato(null);
    setModelloPdfApplicato(null);
    setTemplateApplicato(null);
    setLottoPdf(null);
  };

  const value = {
    moduloAttivo, setModuloAttivo,
    tracciato, setTracciato,
    fileCaricato, setFileCaricato,
    templateAttivo, setTemplateAttivo,
    mapping, setMapping,
    colonneNascoste, setColonneNascoste,
    righeMappate, setRigheMappate,
    pdfCaricato, setPdfCaricato,
    modelloPdfApplicato, setModelloPdfApplicato,
    templateApplicato, setTemplateApplicato,
    lottoPdf, setLottoPdf,
    risultatoPdfOrdini, setRisultatoPdfOrdini,
    moduliAttivi, setModuliAttivi,
    resetFlusso,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

export function useApp() {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useApp deve essere usato dentro AppProvider");
  return ctx;
}
